@if (!isConfigured) {
    <i 
        class="pi pi-circle-fill pending-configuration-state-icon"
        [pTooltip]="l('::PendingConfiguration')">
    </i>
} @else {
    <i 
        class="pi pi-circle-fill configured-configuration-state-icon"
        [pTooltip]="l('::Configured')">
    </i>
}